'use client';

import { ImageWithFallback } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/shared/produce-grid/styles.module.css';
import { cocoaInfoText, cocoaText, cocoyamsInfoText, cocoyamsText, palmsInfoText, palmsText, plantainsInfoText, plantainsText, produceLineColumn, unitColumn, unitPerBag, unitPerBunch, unitPerKg, unitPerLitre, viewText } from '@pieleaf/translations';
import Link from 'next/link';
import { useParams } from 'next/navigation';

const CATEGORIES = [
  { href: '/produce/cocoa', image: '/images/produce/cocoa-main.jpg', info: cocoaInfoText, testId: 'produce-row-cocoa', title: cocoaText, unit: unitPerKg },
  { href: '/produce/cocoyam', image: '/images/produce/cocoyam.webp', info: cocoyamsInfoText, testId: 'produce-row-cocoyam', title: cocoyamsText, unit: unitPerBag },
  { href: '/produce/palm', image: '/images/produce/palm.jpg', info: palmsInfoText, testId: 'produce-row-palm', title: palmsText, unit: unitPerLitre },
  { href: '/produce/plantain', image: '/images/produce/plantain.jpg', info: plantainsInfoText, testId: 'produce-row-plantain', title: plantainsText, unit: unitPerBunch },
];

export type ProduceGridProps = {
  showHeader?: boolean;
};

export const ProduceGrid = ({ showHeader = false }: ProduceGridProps) => {
  const params = useParams();
  const lang = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(lang);

  return (
    <div className={s.table} data-testid='produce-grid'>
      {showHeader ? (
        <div className={s.headRow}>
          <span />
          <span>{produceLineColumn[language]}</span>
          <span>{unitColumn[language]}</span>
          <span />
        </div>
      ) : null}

      {CATEGORIES.map(category => (
        <Link className={s.row} data-prodantix={`Browse ${category.title.english}`} data-testid={category.testId} href={`/${lang}${category.href}`} key={category.testId}>
          <span className={s.thumb}>
            <ImageWithFallback alt={category.title[language]} fill sizes='72px' src={category.image} />
          </span>
          <span className={s.detail}>
            <span className={s.name}>{category.title[language]}</span>
            <span className={s.summary}>{category.info[language]}</span>
          </span>
          <span className={s.unit}>{category.unit[language]}</span>
          <span className={s.action}>{viewText[language]}</span>
        </Link>
      ))}
    </div>
  );
};
